import React, { useRef, useState, useEffect } from 'react';
import { useDispatch, useSelector } from 'react-redux';

import { Box } from '@mui/material';
import { useTranslation } from 'next-i18next';

import { StyleDescription } from './style';

import InteractiveContentModal, {
  InteractiveContentModalProps,
} from '@components/atoms/dialog/interactiveContentModal';
import { IArticle, IInteractiveContentSubmissions, IInteractiveContent, InteractionType } from '@interfaces/learning';
import InteractiveContentActions from '@redux/interactiveContent/actions';
import { RootState } from '@redux/reducer';
import learning from 'src/api/learning';
import { ALLOW_SANITIZE_ATTRIBUTES, ALLOW_SANITIZE_TAGS } from 'src/helpers/constants';
import { sanitize } from 'src/helpers/utils';

export type InteractiveArticleProps = Pick<InteractiveContentModalProps, 'onClose' | 'containerRef' | 'open'> & {
  interactiveContent: IInteractiveContent;
  isPreview?: boolean;
};

const InteractiveArticle = ({ open, interactiveContent, onClose, isPreview = false }: InteractiveArticleProps) => {
  const content = interactiveContent.content as IArticle;
  const { name, description } = content;

  const { t } = useTranslation();
  const containerRef = useRef(null);
  const dispatch = useDispatch();

  const { interactiveContentSubmission, isInteractiveContentSubmissionLoading } = useSelector(
    (state: RootState) => state.InteractContent,
  );

  const startInteractionContent = async () => {
    const started_at = new Date().toISOString();

    const payload = {
      type: InteractionType.ARTICLE,
      article_id: content.id,
      started_at,
    };

    dispatch(InteractiveContentActions.start_interactive_content(interactiveContent.id, payload));
  };

  useEffect(() => {
    if (!isPreview && !isInteractiveContentSubmissionLoading && open && !interactiveContentSubmission) {
      startInteractionContent();
    }
  }, [open]);

  return (
    <InteractiveContentModal open={open} containerRef={containerRef} onClose={onClose}>
      <Box p={5} overflow="auto">
        <StyleDescription
          fontSize={22}
          dangerouslySetInnerHTML={sanitize(description, {
            allowedTags: [...ALLOW_SANITIZE_TAGS, 'font'],
            allowedAttributes: {
              ...ALLOW_SANITIZE_ATTRIBUTES,
              '*': [...ALLOW_SANITIZE_ATTRIBUTES['*'], 'color', 'bgcolor', 'background'],
            },
            allowedStyles: undefined,
          })}
        />
      </Box>
    </InteractiveContentModal>
  );
};

export default InteractiveArticle;
